var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"module-batch-operate"},[_c('div',{staticClass:"module-first"},[_c('div',[_c('el-button',{attrs:{"type":"primary","size":"mini","plain":""}},[_vm._v("导入数据")]),_c('el-button',{attrs:{"type":"primary","size":"mini"}},[_vm._v("批量修改类目")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }